import { render, staticRenderFns } from "./CustomerCashAccount.vue?vue&type=template&id=20d57da0&scoped=true&"
import script from "./CustomerCashAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerCashAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCashAccount.vue?vue&type=style&index=0&id=20d57da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d57da0",
  null
  
)

export default component.exports